import { z } from "zod";

import { FORM_VALIDATOR } from "../Common/formUtils";
import { USER_TYPE } from "../constants/UserTypeConstants";

export const getWelcomeToRooRegistrationFormSchema = () =>
  z
    .object({
      selectedUserType: z.number(),
      hospitalName: z.string().optional(),
      isCorporateGroup: z.boolean().optional(),
      selfIdentifiedEnterpriseName: z.string().optional(),
      anticipatedReliefNeed: z.number().optional(),
      firstName: z.string().optional(),
      lastName: z.string().optional(),
    })
    .superRefine((data, context) => {
      if (data.selectedUserType === USER_TYPE.HOSPITAL_USER_TYPE) {
        if (!data.hospitalName || data.hospitalName?.trim() === "") {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: "This field is required",
            path: ["hospitalName"],
          });
        }
        if (data.anticipatedReliefNeed === undefined || data.anticipatedReliefNeed === null) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: "This field is required",
            path: ["anticipatedReliefNeed"],
          });
        }
        if (
          data.isCorporateGroup &&
          (!data.selfIdentifiedEnterpriseName || data.selfIdentifiedEnterpriseName?.trim() === "")
        ) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Required",
            path: ["selfIdentifiedEnterpriseName"],
          });
        }
      } else {
        if (!data.firstName || data.firstName?.trim() === "") {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: "This field is required",
            path: ["firstName"],
          });
        }

        if (!data.lastName || data.lastName?.trim() === "") {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: "This field is required",
            path: ["lastName"],
          });
        }
      }
    });

export const getHospitalProfileRegistrationFormSchema = () =>
  z.object({
    hospitalAddress: z
      .string({ message: "This field is required" })
      .min(1, { message: "This field is required" }),
    hospitalCity: z
      .string({ message: "This field is required" })
      .min(1, { message: "This field is required" }),
    hospitalState: z.number({ message: "This field is required" }),
    hospitalZipcode: z
      .string({ message: "This field is required" })
      .regex(/^\d{5}$/, { message: "Zip code must be 5 digits" }),
    hospitalPhoneNumber: z.string({ message: "This field is required" }).min(10, {
      message: "Please enter a valid phone number",
    }),
    typeOfHospital: z.number({ message: "This field is required" }),
    hearAboutRoo: z.number({ message: "This field is required" }).optional(),
  });

export const getHospitalUserAccountRegistrationFormSchema = () =>
  z.object({
    firstName: z.string({ message: "This field is required" }),
    lastName: z.string({ message: "This field is required" }),
    mobilePhoneNumber: z.string({ message: "This field is required" }).min(10, {
      message: "Please enter a valid phone number",
    }),
    emailId: z.string({ message: "This field is required" }).email("Please enter a valid email"),
    password: z.string({ message: "This field is required" }).refine(FORM_VALIDATOR.isPassword, {
      message: "Please enter a valid password",
    }),
  });
